import React from 'react'
import HomePage from '@pages/home/HomePage'
import {ROOT_PATH} from '@constants/config'
import ReportsPage from '@pages/reports/ReportsPage'
import {
	PATH_ACTIVE_SINGLE_VOYAGE_WIDTH_ID,
	PATH_ACTIVE_SINGLE_VOYAGES,
	PATH_AUTO_TRACKING,
	PATH_AUTO_TRACKING_GROUPS,
	PATH_BOARDS,
	PATH_VOYAGE_STADIUM,
	PATH_CAMERA_SNAPSHOTS_BY_TIME,
	PATH_CAMERAS_LIST,
	PATH_CREATE_FROM_HISTORY_SINGLE_VOYAGE_WIDTH_ID,
	PATH_CREATE_SINGLE_VOYAGE,
	PATH_DEVICE_ACTIVITY,
	PATH_EQUIPMENT,
	PATH_DASHBOARD,
	PATH_ADMIN_ACCOUNTS,
	PATH_ADMIN_ACCOUNT_EDIT,
	PATH_ADMIN_USERS,
	PATH_ADMIN_USER_NEW,
	PATH_ADMIN_USER_EDIT,
	PATH_ADMIN_DEVICES,
	PATH_ADMIN_DEVICE_EDIT,
	PATH_ADMIN_EMPLOYEES,
	PATH_ADMIN_EMPLOYEE_EDIT,
	PATH_ADMIN_UNREGISTERED,
	PATH_DEVICE_OPERATIONAL_STATISTIC,
	PATH_DEVICE_OPERATIONAL_STATISTIC_BY_DEVICES,
	PATH_EMPLOYEES_LIST,
	PATH_GROUPS,
	PATH_HISTORY_SINGLE_VOYAGE_WIDTH_ID,
	PATH_HISTORY_SINGLE_VOYAGES,
	PATH_MAP_GEO_ZONES,
	PATH_MAP_AREA_SEARCH,
	PATH_MONITORING_PLATFORM,
	PATH_MONITORING_SINGLE_VOYAGES,
	PATH_POINTS_TEMPLATES_SINGLE_VOYAGE,
	PATH_CREATE_VOYAGE_TEMPLATE_SINGLE_VOYAGE,
	PATH_READERS_SINGLE_VOYAGE,
	PATH_VIDEO_SINGLE_VOYAGE,
	PATH_UPDATE_VOYAGE_TEMPLATE_SINGLE_VOYAGE_WIDTH_ID,
	PATH_VOYAGE_TEMPLATE_PLANNING_SINGLE_VOYAGE,
	PATH_VOYAGE_TEMPLATES_SINGLE_VOYAGE,
	PATH_REPORT_BUILDER,
	PATH_REPORT_MILEAGE_SUMMARY,
	PATH_REPORT_CAR_WASH_GEO_ZONE_VISITS,
	PATH_REPORT_DEVICE_PLANNING_EXECUTION,
	PATH_REPORT_EXECUTION_SINGLE_VOYAGE,
	PATH_REPORT_FUEL_CONSUMPTION_BY_DEVICE,
	PATH_REPORT_FUEL_CONSUMPTION_BY_ROUTE,
	PATH_REPORT_GROUP_ACTIVE_SESSIONS,
	PATH_REPORT_GROUP_MILEAGE,
	PATH_REPORT_ICCIDS,
	PATH_REPORT_RECEIVED,
	PATH_REPORT_SCHEDULE_EXECUTION_BY_ROUTES,
	PATH_REPORT_TRACKER_OUTAGES,
	PATH_REPORT_VOYAGE_POINT_AVERAGES,
	PATH_REPORT_VOYAGE_POINT_DATA,
	PATH_REPORT_RFID_SINGLE_VOYAGE,
	PATH_REPORT_DAILY_EXECUTION_SINGLE_VOYAGE,
	PATH_REPORTS,
	PATH_REPORTS_SINGLE_VOYAGE,
	PATH_SCHEDULED_SINGLE_VOYAGES,
	PATH_SMS_DASHBOARD,
	PATH_STATISTIC,
	PATH_TASKS_SINGLE_VOYAGES_WIDTH_ID,
	PATH_TASKS_TEMPLATE_SINGLE_VOYAGES,
	PATH_TRACK_ADVANCED,
	PATH_TRACK_ADVANCED_GROUP,
	PATH_TRACKABLE_OBJECTS_SINGLE_VOYAGE,
	PATH_UPDATE_SINGLE_VOYAGE_WIDTH_ID, PATH_VIDEO_STREAMS,
	PATH_VOYAGE_PLANNING,
	PATH_VOYAGE_PLANNING_WITH_LOCAL_STATE,
	PATH_VOYAGES_AUDIT
} from '@constants/navigate'
import ReportReceivedPage from '@pages/reports/reportReceivedPage/ReportReceivedPage'
import ReportBuilderPage from '@pages/reports/reportBuilderPage/ReportBuilderPage'
import ReportVoyagePointDataPage from '@pages/reports/reportVoyagePointDataPage/ReportVoyagePointDataPage'
import ReportGroupMileagePage from '@pages/reports/reportGroupMileagePage/ReportGroupMileagePage'
import GeoZonesMapPage from '@pages/map/geoZonesMapPage/GeoZonesMapPage'
import TrackAdvancedPage from '@pages/map/trackAdvancedPage/TrackAdvancedPage'
import AreaSearchPage from '@pages/map/areaSearchPage/AreaSearchPage'
import TrackAdvancedGroupPage from '@pages/map/trackAdvancedGroupPage/TrackAdvancedGroupPage'
import AutoTrackingPage from '@pages/map/autoTrackingPage/AutoTrackingPage'
import AutoTrackingGroupsPage from '@pages/map/autoTrackingGroupsPage/AutoTrackingGroupsPage'
import StatisticPage from '@pages/statistic/StatisticPage'
import DeviceOperationalStatisticPage
	from '@pages/statistic/deviceOperationalStatisticPage/DeviceOperationalStatisticPage'
import GroupsPage from '@pages/groups/GroupsPage'
import CreateSingleVoyagePage from '@pages/singleVoyage/createSingleVoyagePage/CreateSingleVoyagePage'
import UpdateSingleVoyagePage from '@pages/singleVoyage/updateSingleVoyagePage/UpdateSingleVoyagePage'
import ScheduledSingleVoyagesPage from '@pages/singleVoyage/scheduledSingleVoyagesPage/ScheduledSingleVoyagesPage'
import ActiveSingleVoyagesPage from '@pages/singleVoyage/activeSingleVoyagesPage/ActiveSingleVoyagesPage'
import {Route, Routes} from 'react-router-dom'
import ActiveSingleVoyagePage from '@pages/singleVoyage/activeSingleVoyagePage/ActiveSingleVoyagePage'
import MonitoringSingleVoyagesPage from '@pages/singleVoyage/monitoringSingleVoyagesPage/MonitoringSingleVoyagesPage'
import HistorySingleVoyagesPage from '@pages/singleVoyage/historySingleVoyagesPage/HistorySingleVoyagesPage'
import HistorySingleVoyagePage from '@pages/singleVoyage/historySingleVoyagePage/HistorySingleVoyagePage'
import CreateFromHistorySingleVoyagePage
	from '@pages/singleVoyage/createFromHistorySingleVoyagePage/CreateFromHistorySingleVoyagePage'
import ReportScheduleExecutionByRoutesPage
	from '@pages/reports/reportScheduleExecutionPage/ReportScheduleExecutionByRoutesPage'
import DeviceActivityPage from '@pages/deviceActivity/DeviceActivityPage'
import DeviceOperationalStatisticByDevicesPage
	from '@pages/statistic/deviceOperationalStatisticPage/DeviceOperationalStatisticByDevicesPage'
import ReportDevicePlanningExecutionPage
	from '@pages/reports/reportDevicePlanningExecutionPage/ReportDevicePlanningExecutionPage'
import ReportFuelConsumptionByDevicePage
	from '@pages/reports/reportFuelConsumptionPage/ReportFuelConsumptionByDevicePage'
import ReportFuelConsumptionByRoutePage from '@pages/reports/reportFuelConsumptionPage/ReportFuelConsumptionByRoutePage'
import VoyagePlanningPage from '@pages/voyagePlanning/VoyagePlanningPage'
import ReportGroupActiveSessionsPage from '@pages/reports/reportGroupActiveSessionsPage/ReportGroupActiveSessionsPage'
import BoardsPage from '@pages/boards/BoardsPage'
import VoyageStadiumPage from '@pages/voyageStadium/VoyageStadiumPage'
import TasksTemplateSingleVoyagesPage
	from '@pages/singleVoyage/tasksTemplateSingleVoyagesPage/TasksTemplateSingleVoyagesPage'
import TasksSingleVoyagePage from '@pages/singleVoyage/tasksSingleVoyagePage/TasksSingleVoyagePage'
import VoyagePlanningWithLocalStatePage from '@pages/voyagePlanning/VoyagePlanningWithLocalStatePage'
import ReportExecutionSingleVoyagePage
	from '@pages/singleVoyage/reports/reportExecution/ReportExecutionSingleVoyagePage'
import ReportRfidSingleVoyagePage
	from '@pages/singleVoyage/reports/reportRfid/ReportRfidSingleVoyagePage'
import ReportDailyExecutionSingleVoyagePage
	from '@pages/singleVoyage/reports/reportDailyExecution/ReportDailyExecutionSingleVoyagePage'
import AllReportsSingleVoyagePage from '@pages/singleVoyage/reports/AllReportsSingleVoyagePage'
import VoyagesAuditPage from '@pages/audit/voyagesAudit/VoyagesAuditPage'
import CamerasListPage from '@pages/cameras/camerasList/CamerasListPage'
import CameraSnapStopByTimePage from '@pages/cameras/cameraSnapshotsByTime/CameraSnapStopByTimePage'
import EmployeesListPage from '@pages/employees/employeesList/EmployeesListPage'
import ReportVoyagePointAveragesPage from '@pages/reports/reportVoyagePointDataPage/ReportVoyagePointAveragesPage'
import PointTemplatesSingleVoyagePage
	from '@pages/singleVoyage/pointTemplatesSingleVoyagePage/PointTemplatesSingleVoyagePage'
import TrackableObjectsSingleVoyagesPage
	from '@pages/singleVoyage/trackableObjectsVoyagesPage/TrackableObjectsSingleVoyagesPage'
import ReadersSingleVoyagesPage from '@pages/singleVoyage/readersVoyagesPage/ReadersSingleVoyagesPage'
import VideoSingleVoyagesPage from '@pages/singleVoyage/videoVoyagesPage/VideoSingleVoyagesPage'
import ReportIccidsPage from '@pages/reports/reportIccidsPage/ReportIccidsPage'
import {SmsAdminPage} from '@pages/smsAdmin/SmsAdminPage'
import {AdminAccountsPage} from '@pages/adminAccounts/AdminAccountsPage'
import {AdminAccountEditPage} from '@pages/adminAccounts/AdminAccountEditPage'
import {
	AdminDeviceEditPage,
	AdminDevicesPage,
	AdminEmployeeEditPage,
	AdminEmployeesPage,
	AdminUnregisteredPage,
	AdminUserEditPage,
	AdminUserNewPage,
	AdminUsersPage
} from '@pages/adminSystem/AdminSystemPages'
import ReportCarWashGeoZoneVisitsPage
	from '@pages/reports/reportCarWashGeoZoneVisitsPage/ReportCarWashGeoZoneVisitsPage'
import VideoStreamsListPage from '@pages/video/videoStreamsList/VideoStreamsListPage'
import MonitoringPlatformPage from '@pages/monitoringPlatform/MonitoringPlatformPage'
import EquipmentPage from '@pages/equipment/EquipmentPage'
import DashboardPage from '@pages/dashboard/DashboardPage'
import ReportMileageSummaryPage
	from '@pages/reports/reportMileageSummaryPage/ReportMileageSummaryPage'
import ReportTrackerOutagesPage
	from '@pages/reports/reportTrackerOutagesPage/ReportTrackerOutagesPage'
import VoyageTemplatesSingleVoyagePage
	from '@pages/singleVoyage/voyageTemplatesSingleVoyagePage/VoyageTemplatesSingleVoyagePage'
import CreateVoyageTemplatePage from '@pages/singleVoyage/createVoyageTemplatePage/CreateVoyageTemplatePage'
import UpdateVoyageTemplatePage from '@pages/singleVoyage/updateVoyageTemplatePage/UpdateVoyageTemplatePage'
import VoyageTemplatePlanningPage
	from '@pages/singleVoyage/voyageTemplatePlanningPage/VoyageTemplatePlanningPage'


const AuthRoutes = () => {
	return (
		<Routes>
			<Route element={<HomePage/>} path={ROOT_PATH}/>
			<Route element={<VoyageStadiumPage/>} path={PATH_VOYAGE_STADIUM}/>

			<Route element={<ReportsPage/>} path={PATH_REPORTS}/>
			<Route element={<ReportReceivedPage/>} path={PATH_REPORT_RECEIVED}/>
			<Route element={<ReportBuilderPage showBreadcrumbs/>} path={PATH_REPORT_BUILDER}/>
			<Route element={<ReportScheduleExecutionByRoutesPage/>} path={PATH_REPORT_SCHEDULE_EXECUTION_BY_ROUTES}/>
			<Route element={<ReportVoyagePointDataPage/>} path={PATH_REPORT_VOYAGE_POINT_DATA}/>
			<Route element={<ReportGroupMileagePage/>} path={PATH_REPORT_GROUP_MILEAGE}/>
			<Route element={<ReportDevicePlanningExecutionPage/>} path={PATH_REPORT_DEVICE_PLANNING_EXECUTION}/>
			
			<Route element={<ReportFuelConsumptionByDevicePage/>} path={PATH_REPORT_FUEL_CONSUMPTION_BY_DEVICE}/>
			<Route element={<ReportFuelConsumptionByRoutePage/>} path={PATH_REPORT_FUEL_CONSUMPTION_BY_ROUTE}/>
			<Route element={<ReportGroupActiveSessionsPage/>} path={PATH_REPORT_GROUP_ACTIVE_SESSIONS}/>
			<Route element={<ReportCarWashGeoZoneVisitsPage/>} path={PATH_REPORT_CAR_WASH_GEO_ZONE_VISITS}/>
			<Route element={<ReportMileageSummaryPage/>} path={PATH_REPORT_MILEAGE_SUMMARY}/>
			<Route element={<ReportTrackerOutagesPage/>} path={PATH_REPORT_TRACKER_OUTAGES}/>
			
			<Route element={<GeoZonesMapPage/>} path={PATH_MAP_GEO_ZONES}/>
			<Route element={<AreaSearchPage/>} path={PATH_MAP_AREA_SEARCH}/>
			<Route element={<TrackAdvancedPage/>} path={PATH_TRACK_ADVANCED}/>
			<Route element={<TrackAdvancedGroupPage/>} path={PATH_TRACK_ADVANCED_GROUP}/>
			
			<Route element={<AutoTrackingPage/>} path={PATH_AUTO_TRACKING}/>
			<Route element={<AutoTrackingGroupsPage/>} path={PATH_AUTO_TRACKING_GROUPS}/>
			
			<Route element={<StatisticPage/>} path={PATH_STATISTIC}/>
			<Route element={<BoardsPage/>} path={PATH_BOARDS}/>
			
			<Route element={<DeviceOperationalStatisticPage/>}
				   path={PATH_DEVICE_OPERATIONAL_STATISTIC}/>
			
			<Route element={<DeviceOperationalStatisticByDevicesPage/>}
				   path={PATH_DEVICE_OPERATIONAL_STATISTIC_BY_DEVICES}/>
			
			<Route element={<GroupsPage/>} path={PATH_GROUPS}/>
			<Route element={<VoyagePlanningPage/>} path={PATH_VOYAGE_PLANNING}/>
			<Route element={<VoyagePlanningWithLocalStatePage/>} path={PATH_VOYAGE_PLANNING_WITH_LOCAL_STATE}/>
			
			<Route element={<ScheduledSingleVoyagesPage/>} path={PATH_SCHEDULED_SINGLE_VOYAGES}/>
			<Route element={<MonitoringSingleVoyagesPage/>} path={PATH_MONITORING_SINGLE_VOYAGES}/>
			<Route element={<HistorySingleVoyagesPage/>} path={PATH_HISTORY_SINGLE_VOYAGES}/>
			<Route element={<ActiveSingleVoyagesPage/>} path={PATH_ACTIVE_SINGLE_VOYAGES}/>
			<Route element={<TasksTemplateSingleVoyagesPage/>} path={PATH_TASKS_TEMPLATE_SINGLE_VOYAGES}/>
			<Route element={<TasksSingleVoyagePage/>} path={PATH_TASKS_SINGLE_VOYAGES_WIDTH_ID}/>
			
			<Route element={<CreateSingleVoyagePage/>} path={PATH_CREATE_SINGLE_VOYAGE}/>
			<Route element={<UpdateSingleVoyagePage/>} path={PATH_UPDATE_SINGLE_VOYAGE_WIDTH_ID}/>
			<Route element={<CreateFromHistorySingleVoyagePage/>}
				   path={PATH_CREATE_FROM_HISTORY_SINGLE_VOYAGE_WIDTH_ID}/>
			
			<Route element={<ActiveSingleVoyagePage/>} path={PATH_ACTIVE_SINGLE_VOYAGE_WIDTH_ID}/>
			<Route element={<HistorySingleVoyagePage/>} path={PATH_HISTORY_SINGLE_VOYAGE_WIDTH_ID}/>
			<Route element={<DeviceActivityPage/>} path={PATH_DEVICE_ACTIVITY}/>
			
			<Route element={<AllReportsSingleVoyagePage/>} path={PATH_REPORTS_SINGLE_VOYAGE}/>
			<Route element={<ReportExecutionSingleVoyagePage/>} path={PATH_REPORT_EXECUTION_SINGLE_VOYAGE}/>
			<Route element={<ReportRfidSingleVoyagePage/>} path={PATH_REPORT_RFID_SINGLE_VOYAGE}/>
			<Route element={<ReportDailyExecutionSingleVoyagePage/>} path={PATH_REPORT_DAILY_EXECUTION_SINGLE_VOYAGE}/>
			<Route element={<VoyagesAuditPage/>} path={PATH_VOYAGES_AUDIT}/>
			<Route element={<CamerasListPage/>} path={PATH_CAMERAS_LIST}/>
			<Route element={<CameraSnapStopByTimePage/>} path={PATH_CAMERA_SNAPSHOTS_BY_TIME}/>
			<Route element={<EmployeesListPage/>} path={PATH_EMPLOYEES_LIST}/>
			<Route element={<ReportVoyagePointAveragesPage/>} path={PATH_REPORT_VOYAGE_POINT_AVERAGES}/>
			<Route element={<PointTemplatesSingleVoyagePage/>} path={PATH_POINTS_TEMPLATES_SINGLE_VOYAGE}/>
			<Route element={<TrackableObjectsSingleVoyagesPage/>} path={PATH_TRACKABLE_OBJECTS_SINGLE_VOYAGE}/>
			<Route element={<ReadersSingleVoyagesPage/>} path={PATH_READERS_SINGLE_VOYAGE}/>
			<Route element={<VideoSingleVoyagesPage/>} path={PATH_VIDEO_SINGLE_VOYAGE}/>
			<Route element={<VoyageTemplatesSingleVoyagePage/>} path={PATH_VOYAGE_TEMPLATES_SINGLE_VOYAGE}/>
			<Route element={<CreateVoyageTemplatePage/>} path={PATH_CREATE_VOYAGE_TEMPLATE_SINGLE_VOYAGE}/>
			<Route element={<UpdateVoyageTemplatePage/>}
				   path={PATH_UPDATE_VOYAGE_TEMPLATE_SINGLE_VOYAGE_WIDTH_ID}/>
			<Route element={<VoyageTemplatePlanningPage/>}
				   path={PATH_VOYAGE_TEMPLATE_PLANNING_SINGLE_VOYAGE}/>
			<Route element={<ReportIccidsPage/>} path={PATH_REPORT_ICCIDS}/>
			<Route element={<SmsAdminPage/>} path={PATH_SMS_DASHBOARD}/>
			<Route element={<VideoStreamsListPage/>} path={PATH_VIDEO_STREAMS}/>
			<Route element={<MonitoringPlatformPage/>} path={PATH_MONITORING_PLATFORM}/>
			<Route element={<EquipmentPage/>} path={PATH_EQUIPMENT}/>
			<Route element={<DashboardPage/>} path={PATH_DASHBOARD}/>
			<Route element={<AdminAccountsPage/>} path={PATH_ADMIN_ACCOUNTS}/>
			<Route element={<AdminAccountEditPage/>} path={PATH_ADMIN_ACCOUNT_EDIT}/>
			<Route element={<AdminUsersPage/>} path={PATH_ADMIN_USERS}/>
			<Route element={<AdminUserNewPage/>} path={PATH_ADMIN_USER_NEW}/>
			<Route element={<AdminUserEditPage/>} path={PATH_ADMIN_USER_EDIT}/>
			<Route element={<AdminDevicesPage/>} path={PATH_ADMIN_DEVICES}/>
			{/* Creating devices and employees is not finished yet (sensors, defaults); back later. */}
			{/*<Route element={<AdminDeviceNewPage/>} path={PATH_ADMIN_DEVICE_NEW}/>*/}
			<Route element={<AdminDeviceEditPage/>} path={PATH_ADMIN_DEVICE_EDIT}/>
			<Route element={<AdminEmployeesPage/>} path={PATH_ADMIN_EMPLOYEES}/>
			{/*<Route element={<AdminEmployeeNewPage/>} path={PATH_ADMIN_EMPLOYEE_NEW}/>*/}
			<Route element={<AdminEmployeeEditPage/>} path={PATH_ADMIN_EMPLOYEE_EDIT}/>
			<Route element={<AdminUnregisteredPage/>} path={PATH_ADMIN_UNREGISTERED}/>

		</Routes>
	);
};

export default AuthRoutes;
